import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="FLB-logo" alt="Firelight Biosciences" /><br />
        <p>
          Strain engineering, evolved.
        </p>
        <a
          className="App-link"
          href="mailto: contact@firelightbio.com"
          target="_blank"
	  rel="noopener noreferrer"
        >
          Contact Us
        </a>
      </header>
    </div>
  );
}

export default App;
